<form-control-container
  #container
  [control]="controlInstance"
  [class.readonly]="isReadonlyValue"
>
  <div label-extension>
    <ng-content select="[label-extension]"></ng-content>
  </div>
  <ng-container *ngIf="!isReadonlyValue">
    <div class="input-group">
      <ng-content select="[before]"></ng-content>

      <ng-select
        class="waf-select-container"
        bindLabel="displayName"
        [clearable]="clearable"
        [(ngModel)]="selectedOptions"
        [appendTo]="appendToBody ? 'body' : null"
        [closeOnSelect]="closeOnSelect"
        [compareWith]="compareWith"
        [disabled]="disabled"
        [items]="items$ | async"
        [hideSelected]="hideSelected"
        [labelForId]="controlId"
        [loading]="loading"
        [maxSelectedItems]="maxSelectedItems"
        [multiple]="multiple"
        [placeholder]="placeholder"
        [tabIndex]="tabindex"
        [typeahead]="optionsLoaderFunc ? searchOptions$ : null"
        (open)="onOpen()"
        [ngClass]="{ invalid: invalid }"
        (ngModelChange)="onSelectedOptionsChange()"
        (focusout)="touch()"
      >
        <ng-template
          ng-label-tmp
          let-item="item"
          let-label="label"
          let-clear="clear"
          *ngIf="labelTemplate"
        >
          <ng-template
            [ngTemplateOutlet]="labelTemplate"
            [ngTemplateOutletContext]="{
              option: item,
              clear: clear,
              label: label
            }"
          >
          </ng-template>
        </ng-template>

        <ng-template
          ng-option-tmp
          let-item="item"
          let-item$="item$"
          let-index="index"
          let-searchTerm="searchTerm"
          *ngIf="optionTemplate"
        >
          <ng-template
            [ngTemplateOutlet]="optionTemplate"
            [ngTemplateOutletContext]="{
              option: item,
              item: item$,
              index: index,
              searchTerm: searchTerm
            }"
          >
          </ng-template>
        </ng-template>
      </ng-select>

      <ng-content select="[after]"></ng-content>
    </div>
  </ng-container>
  <ng-container *ngIf="isReadonlyValue">
    <ng-container *ngIf="readonlyLabelTemplate && selectedOptions; else defaultReadonly">
      <span class="readonly-value">
        <ng-template
          [ngTemplateOutlet]="readonlyLabelTemplate"
          [ngTemplateOutletContext]="{ option: selectedOptions }"
        ></ng-template>
      </span>
    </ng-container>
    <ng-template #defaultReadonly>
      <span class="readonly-value">{{
        selectedOptions | listOptionToDisplayValue
      }}</span>
    </ng-template>
  </ng-container>
</form-control-container>
